var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-menu"},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:'tab-'+i,staticClass:"its-menu-item",class:{'active':_vm.activeTab==tab.item.key},on:{"click":function($event){return _vm.menuClick(tab.item)}}},[_c('i',{staticClass:"its-icon",class:tab.icon}),_vm._v(" "+_vm._s(tab.mainTitle)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }